import { useState, useEffect } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function ServicesExpenses() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    payment_type: "",
    paid: "",
    customer_id: "",
    services: [
      {
        service_id: "",
        cost: "",
        car_number: "",
        car_type: "",
        car_model: "",
        payer: "",
        value: "",
      },
    ],
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [filters, setFilters] = useState({
    from: "",
    to: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [nextInvoice, setNextInvoice] = useState();

  useEffect(() => {
    API.get("/get-all-customers")
      .then((res) => setCustomers(res.data.data || []))
      .catch(() => toast.error("فشل تحميل العملاء"));

    API.get("/services")
      .then((res) => setServicesList(res.data.data || []))
      .catch(() => toast.error("فشل تحميل الخدمات"));

    API.get("/next-invoice-number")
      .then((res) => setNextInvoice(res.data.next_invoice_number || null))
      .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));
  }, []);

  const handleSearch = () => {
    // if (!filters.from || !filters.to) {
    //     toast.error("من فضلك اختر الفترة (من – إلى)");
    //     return;
    // }

    //     let result = allInvoices;
    //     if (filters.invoice_number) {
    //     result = result.filter((inv) =>
    //         inv.invoice_number?.toString().includes(filters.invoice_number)
    //     );
    // }
    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };

  const total = formData.services.reduce(
    (sum, s) => sum + Number(s.value || 0),
    0
  );
  const remaining = total - Number(formData.paid || 0);

  const handleAdd = () => {
    setFormData({
      date: new Date().toISOString().split("T")[0],
      payment_type: "",
      paid: "",
      customer_id: "",
      services: [
        {
          service_id: "",
          cost: "",
          car_number: "",
          car_type: "",
          car_model: "",
          value: "",
          payer: "",
        },
      ],
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
    // console.log(nextInvoice);
  };

  const handleEdit = (record) => {
    setFormData({ ...record });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
    // console.log(formData);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/invoices/${deleteId}`);
      console.log("تم حذف الفاتورة بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleServiceChange = (index, field, value) => {
    const updated = [...formData.services];
    updated[index][field] = value;
    setFormData({ ...formData, services: updated });
  };

  const addService = () => {
    setFormData({
      ...formData,
      services: [
        ...formData.services,
        {
          service_id: "",
          cost: "",
          car_number: "",
          car_type: "",
          car_model: "",
          payer: "",
          value: "",
        },
      ],
    });
  };

  const removeService = (index) => {
    const updated = formData.services.filter((_, i) => i !== index);
    setFormData({ ...formData, services: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {
      if (editId) {
        await API.put(`/invoices/${editId}`, formData);
        console.log("تم تعديل الفاتورة بنجاح");
      } else {
        await API.post("/invoices", formData);
        console.log("تم إضافة الفاتورة بنجاح");
      }
      setShowModal(false);
      API.get("/next-invoice-number")
        .then((res) => setNextInvoice(res.data.next_invoice_number || null))
        .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        console.log("حدث خطأ أثناء الحفظ");
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: "رقم الفاتورة", accessor: "invoice_number" },
    { header: "التاريخ", accessor: "date" },
    { header: "إجمالي السعر", accessor: "total_price" },
    { header: "تكلفة الخدمة", accessor: "total_cost" },
    { header: "الربح", accessor: "profit" },
  ];

  const profit = formData.services.reduce(
    (sum, s) => sum + (Number(s.value || 0) - Number(s.cost || 0)),
    0
  );
  useEffect(() => {
    const today = new Date();

    // أول يوم في الشهر الحالي
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    // آخر يوم في الشهر الحالي
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    // نحول التاريخ إلى صيغة YYYY-MM-DD بدون UTC
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFilters({ ...filters, to: formatDate(lastDay), from: formatDate(firstDay) });
  }, []);
  return (
    <div className="container mt-5">
      <Mytitle title="تقرير مصروفات الخدمات" />
      {/* <Can permission="invoice_create">

                <MyButton
                    text="إضافة فاتورة"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}
      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={`${editId ? "تعديل فاتورة" : "إضافة فاتورة"} (${
          formData.invoice_number ? formData.invoice_number : nextInvoice
        })`}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form"
        className="invoices-modal">
        <div className="form-grid">
          {/* <div className="form-group">
                        <MyInput
                            label="رقم الفاتورة"
                            value={formData.invoice_number}
                            onChange={(e) => setFormData({ ...formData, invoice_number: e.target.value })}
                            error={errors.invoice_number?.[0]}
                            disabled={!!editId}
                        />
                    </div> */}

          <div className="form-group">
            <MyInput
              label="التاريخ"
              type="date"
              value={formData.date}
              onChange={(e) =>
                setFormData({ ...formData, date: e.target.value })
              }
              error={errors.date?.[0]}
            />
          </div>

          <div className="form-group">
            <MyInput
              as="select"
              // label="طريقة الدفع"
              value={formData.payment_type}
              onChange={(e) =>
                setFormData({ ...formData, payment_type: e.target.value })
              }
              error={errors.payment_type?.[0]}
              options={[
                { value: "", label: "اختر طريقة الدفع" },
                { value: "cash", label: "كاش" },
                { value: "credit", label: "آجل" },
                { value: "bank_transfer", label: "تحويل بنكي" },
                { value: "card", label: "شبكة" },
              ]}
              disabled={editId}
            />
          </div>

          {/* {!editId  && ( */}
          <div className="form-group">
            <MyInput
              as="select"
              // label="العميل"
              value={formData.customer_id}
              onChange={(e) =>
                setFormData({ ...formData, customer_id: e.target.value })
              }
              error={errors.customer_id?.[0]}
              options={[
                { value: "", label: "اختر العميل" },
                ...customers.map((c) => ({ value: c.id, label: c.name })),
              ]}
              disabled={editId}
            />
          </div>
          {/* )} */}
        </div>

        <div className="scroll-invoice-table">
          {!(formData.payment_type !== "cash" && editId) && (
            <button
              type="button"
              className="add-service-btn"
              onClick={addService}>
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}

          <table className="services-table">
            <thead>
              <tr>
                <th style={{ width: "250px" }}>الخدمة</th>
                <th style={{ width: "120px" }}>التكلفة</th>
                <th style={{ width: "120px" }}>السعر</th>
                <th>رقم السيارة</th>
                <th>النوع</th>
                <th>الموديل</th>
                <th>المخلص</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {formData.services.map((srv, index) => (
                <tr key={index}>
                  <td>
                    <select
                      value={srv.service_id}
                      onChange={(e) =>
                        handleServiceChange(index, "service_id", e.target.value)
                      }
                      disabled={formData.payment_type !== "cash" && editId}>
                      <option value="">اختر الخدمة</option>
                      {servicesList.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      type="number"
                      value={srv.cost}
                      onChange={(e) =>
                        handleServiceChange(index, "cost", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={srv.value}
                      onChange={(e) =>
                        handleServiceChange(index, "value", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    <input
                      value={srv.car_number}
                      onChange={(e) =>
                        handleServiceChange(index, "car_number", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    <input
                      value={srv.car_type}
                      onChange={(e) =>
                        handleServiceChange(index, "car_type", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    <input
                      value={srv.car_model}
                      onChange={(e) =>
                        handleServiceChange(index, "car_model", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    <input
                      value={srv.payer}
                      onChange={(e) =>
                        handleServiceChange(index, "payer", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    {!(formData.payment_type !== "cash" && editId) && (
                      <button
                        type="button"
                        className="delete-service-btn"
                        onClick={() => removeService(index)}>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="invoice-footer">
          {formData.payment_type !== "cash" && (
            <>
              <MyInput label="المتبقي" value={remaining} disabled />
              <MyInput
                label="المدفوع"
                type="number"
                value={formData.paid}
                onChange={(e) =>
                  setFormData({ ...formData, paid: e.target.value })
                }
                error={errors.paid?.[0]}
              />
            </>
          )}
          <MyInput label="الإجمالي" value={total} disabled />
          <MyInput label="الربح" value={profit} disabled />
        </div>
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذه الفاتورة؟
      </ModalForm>

      <div className="row flex-row-reverse mb-3">
        <div className="col-md-2">
          <MyInput
            label="من"
            type="date"
            value={filters.from}
            onChange={(e) => setFilters({ ...filters, from: e.target.value })}
            dontShowDay={true}
          />
        </div>

        <div className="col-md-2">
          <MyInput
            label="إلى"
            type="date"
            value={filters.to}
            onChange={(e) => setFilters({ ...filters, to: e.target.value })}
            dontShowDay={true}
          />
        </div>
        {/* <div className="col-md-2">
                    <MyInput
                        label="رقم الفاتورة"
                        type="search"
                        value={filters.invoice_number}
                        onChange={(e) =>
                            setFilters({ ...filters, invoice_number: e.target.value })
                        }
                        dontShowDay={true}
                    />
                </div> */}

        <div className="col-md-1 d-flex align-items-center">
          <MyButton onClick={handleSearch} text="بحث" />
        </div>
      </div>

      <MyTable
        resource="expense-invoice"
        method="post"
        title={"تقرير مصروفات الخدمات"}
        body={appliedFilters}
        columns={columns}
        refreshKey={refreshKey}
        // invoiceNumber={filters.invoice_number}
      />
    </div>
  );
}

export default ServicesExpenses;
